import { combineReducers } from 'redux';
import Address from './Address';
import City from './City';
import Country from './Country';
import UnitHome from './UnitHome';
import Location from './Location';
import District from './District';
import GeographicZone from './GeographicZone';
import Region from './Region';
import DistrictPostalCode from './DistrictPostalCode';

export default combineReducers({
  UnitHome,
  Address,
  City,
  Region,
  Country,
  Location,
  District,
  GeographicZone,
  DistrictPostalCode,
});
